// src/context/CanvasContext.js
import { createContext, useContext, useRef, useEffect, useState } from "react";
import { Canvas } from "fabric";

const CanvasContext = createContext();

let globalCanvas = null;

export function CanvasProvider({ children }) {
  const [canvas, setCanvas] = useState(globalCanvas);

  const initCanvas = (el) => {
    if (!el) return;
    if (globalCanvas) {
      console.log("CANVAS ALREADY EXISTS — REUSING", globalCanvas);
      setCanvas(globalCanvas);
      return;
    }

    console.log("CREATING ETERNAL CANVAS", {
      width: el.clientWidth,
      height: el.clientHeight,
    });

    const fabricCanvas = new Canvas(el, {
      width: el.clientWidth || 800,
      height: el.clientHeight || 600,
      backgroundColor: "#ffffff",
      preserveObjectStacking: true,
      selection: true,
    });

    globalCanvas = fabricCanvas;
    setCanvas(fabricCanvas);
    console.log("CANVAS CREATED AND CONTEXT UPDATED", fabricCanvas);
  };

  useEffect(() => {
    return () => {
      if (process.env.NODE_ENV === "production" && globalCanvas) {
        console.log("PRODUCTION: Disposing canvas");
        globalCanvas.dispose();
        globalCanvas = null;
      }
    };
  }, []);

  return (
    <CanvasContext.Provider value={{ canvas, initCanvas }}>
      {children}
    </CanvasContext.Provider>
  );
}

export const useCanvas = () => {
  const context = useContext(CanvasContext);
  if (!context) throw new Error("useCanvas must be used within CanvasProvider");
  return context;
};
